import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const userApi = createApi({
  reducerPath: "userApi",
  tagTypes: ["Auth"], // 👈 add tag type
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
    prepareHeaders: (headers) => {
      // avoid HTTP caching at network layer (defensive)
      headers.set("Cache-Control", "no-store");
      headers.set("Pragma", "no-cache");
      headers.set("Expires", "0");
      return headers;
    },
  }),
  endpoints: (builder) => ({

    sendRegisterOtp: builder.mutation({
  query: (body) => ({
    url: "/users/send-register-otp",
    method: "POST",
    body,
  }),
}),

    addUser: builder.mutation({
      query: (newUser) => ({
        url: "/users/create-user",
        method: "POST",
        body: newUser,
      }),
    }),

    loginUser: builder.mutation({
      query: (user) => ({
        url: "/users/login-user",
        method: "POST",
        body: user,
      }),
      // login hone ke baad /me ko refetch karwana ho to:
      invalidatesTags: ["Auth"],
    }),

    getLoggedInUser: builder.query({
      query: () => "/users/me",
      providesTags: ["Auth"],
      keepUnusedDataFor: 0,                 // 👈 cache hold time = 0
      refetchOnMountOrArgChange: true,      // 👈 component mount pe refetch
      refetchOnFocus: true,                 // (optional) tab focus par refetch
      refetchOnReconnect: true,             // (optional) network reconnect par refetch
    }),

    logoutUser: builder.mutation({
      query: () => ({
        url: "/users/logout-user",
        method: "POST",
      }),
      // logout ke baad me ko invalid kar do
      invalidatesTags: ["Auth"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          // (A) agar aapke paas user slice hai:
          // dispatch(clearUser());

          // (B) RTKQ ka pura cache saaf (strongest option)
          dispatch(userApi.util.resetApiState());
        } catch {}
      },
    }),

    getHelperSyncToken: builder.query({
  query: () => "/users/helper-sync-token",
  keepUnusedDataFor: 0,
}),

     requestOtp: builder.mutation({
      query: (body) => ({
        url: "/auth/request-otp",
        method: "POST",
        body,
      }),
    }),

    verifyOtp: builder.mutation({
      query: (body) => ({
        url: "/auth/verify-otp",
        method: "POST",
        body,
      }),
    }),

    

    resetPassword: builder.mutation({
      query: (body) => ({
        url: "/auth/reset-password",
        method: "POST",
        body,
      }),
    }),
forgotByEmail: builder.mutation({
  query: (payload) => ({
    url: "/auth/forgot",
    method: "POST",
    body: payload,
  }),
}),
requestOtpByEmail: builder.mutation({
  query: (payload) => ({
    url: "/auth/request-otp-by-email",
    method: "POST",
    body: payload,
  }),
}),

getUserByEmail: builder.query({
  query: ({ email }) => `/auth/get-user-by-email?email=${email}`,
  
}),

saveFcmToken: builder.mutation({
  query: (token) => ({
    url: "/users/save-fcm-token",
    method: "POST",
    body: { token },
  }),
}),

getTenantInfo: builder.query({
  query: () => "/users/tenant-info",
  providesTags: ["Auth"],
  keepUnusedDataFor: 0,
  refetchOnMountOrArgChange: true,
  refetchOnFocus: true,
  refetchOnReconnect: true,
}),

employeeLogin: builder.mutation({
  query: (body) => ({
    url: "/auth/employee-login",
    method: "POST",
    body,
    credentials: "include",
  }),
  invalidatesTags: ["Auth"],
}),



employeeRequestOtp: builder.mutation({
  query: (body) => ({
    url: "/auth/employee/request-otp",
    method: "POST",
    body,
  }),
}),

employeeVerifyOtp: builder.mutation({
  query: (body) => ({
    url: "/auth/employee/verify-otp",
    method: "POST",
    body,
  }),
}),

employeeResetPassword: builder.mutation({
  query: (body) => ({
    url: "/auth/employee/reset-password",
    method: "POST",
    body,
  }),
}),

  }),
});

export const {
  useLoginUserMutation,
  useGetLoggedInUserQuery,
  useGetTenantInfoQuery,
useLazyGetHelperSyncTokenQuery,
  useAddUserMutation,
  useSendRegisterOtpMutation,
  useLogoutUserMutation,
  useRequestOtpMutation,
  useVerifyOtpMutation,
  useResetPasswordMutation,
  useForgotByEmailMutation,
  useRequestOtpByEmailMutation,
  useLazyGetUserByEmailQuery,
    useSaveFcmTokenMutation,
    useEmployeeLoginMutation,
    useEmployeeRequestOtpMutation,
useEmployeeVerifyOtpMutation,
useEmployeeResetPasswordMutation,

} = userApi;

export default userApi;
